<woo-modal-layout size="medium" (close)="close()">
    <h3 header>Villkor för spelbolag i WOO Manager</h3>
    <p>Att kunden är ett spelbolag innebär tillåtna styrningar för kampanjen.</p>
    Videokampanj:
    <ul>
      <li>RBS</li>
      <li>Kategori sport (max filmlängd 15s)</li>
    </ul>
    Pausreklam:
    <ul>
      <li>RBS</li>
    </ul>
    <button class="button primary-1 button-width sm" (click)="close()">Stäng</button>
</woo-modal-layout>